import React, { useState, useEffect } from "react";
import Breadcrumb from "../Component/Layout/Breadcrumb";
import "../assets/css/ProductDetialsbox.css";
import GalleryImage from "./GalleryImage";
import { Link } from "react-router-dom";
import SearchFilter from "../Component/Layout/SearchFilter";
// import SpecifIcation from "../Component/Common/SpecifIcation";
import CartList from "../Component/Checkout/CartList";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ProductShorting from "../Component/Common/ProductShorting";
import img001 from '../../src/assets/images/c1.jpg'
import img002 from '../../src/assets/images/c2.jpg'
import img003 from '../../src/assets/images/c3.jpg'
import img004 from '../../src/assets/images/c4.jpg'
import img005 from '../../src/assets/images/c5.jpg'
import img006 from '../../src/assets/images/c4.jpg'
import img007 from '../../src/assets/images/c5.jpg'
import img008 from '../../src/assets/images/c3.jpg'
import img009 from '../../src/assets/images/c2.jpg'
import img0010 from '../../src/assets/images/c1.jpg'
import img0011 from '../../src/assets/images/c2.jpg'
import img0012 from '../../src/assets/images/c5.jpg'
import img0013 from '../../src/assets/images/c2.jpg'
import img0014 from '../../src/assets/images/c1.jpg'
import img0015 from '../../src/assets/images/c2.jpg'
import img0016 from '../../src/assets/images/c5.jpg'

function ProductDetails() {
  const productImages = [
    { img: img001, name: "Carpet 295553S"   },
    { img: img002, name: "Carpet 295563S"   },
    { img: img003, name: "Carpet 290053S"   },
    { img: img004, name: "Carpet 2955544"   },
    { img: img005, name: "Carpet 295893S"   },
    { img: img006, name: "Carpet 282553R"   },
    { img: img007, name: "Carpet 295553S"   },
    { img: img008, name: "Carpet 2955639"   },
    { img: img009,  name: "Carpet 2900532"  },
    { img: img0010, name: "Carpet 29555RR"  },
    { img: img0011, name: "Carpet 295893J"  },
    { img: img0012, name: "Carpet 282553N"  }, 
    { img: img0013,  name: "Carpet 2900532" },
    { img: img0014, name: "Carpet 29555RR"  },
    { img: img0015, name: "Carpet 295893J"  },
    { img: img0016, name: "Carpet 282553N"  },
  ];

  const [selectedImage, setSelectedImage] = useState(productImages[0]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate data fetching delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 2 seconds delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
      <>
     <Breadcrumb />
        <section className="Product-Detials-box">
          <div className="container">
            <div className="row">
              {/* Left side main image */}
              <div className="col-md-12 col-sm-12 col-12" style={{ borderBottom: "1px solid #e0e0e0", marginBottom: "3px" }}>
              <div className="row">
                  <div className="col-md-6 col-8">
                 {isLoading ? (
                      <Skeleton height={30} />
                    ) : (
                      <SearchFilter />
                    )}
                  </div>
                  <div className="col-md-6 col-4">
                  {isLoading ? (
                      <Skeleton height={30} />
                    ) : (
                      <>
                    <div style={{ display:"flex", justifyContent: "flex-end" }}> 
                    <ProductShorting/>
                        <Link to="/productgraid" className="text-3xl text-gray-500 size-001">
                           <i className="bi bi-grid"></i>
                        </Link>
                    </div>
                    </>
                      )}
                  </div>
                </div>
              </div>
              <div className="col-md-8 order-2 order-sm-1 ">

                {/*-------- Right side thumbnails ---------*/}

                <div className="box-border-collection"> 
                <div className="all-images-box mt-1">
                  <div className="row row-cols-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-4 g-2 text-center">
                    {isLoading
                      ? Array.from({ length: 20 }).map((_, index) => (
                          <div className="col" key={index}>
                            <Skeleton height={180} />
                            <Skeleton width={80} height={10} className="mt-1" />
                          </div>
                        ))
                      : productImages.map((item, index) => (
                          <div className="col" key={index}>
                            <div
                              className="boximg"
                              onClick={() => setSelectedImage(item)}
                              style={{
                                cursor: "pointer",
                                border: selectedImage.img === item.img ? "2px solid rgb(246 135 19)" : "1px solid transparent",
                                padding: "2px",
                                borderRadius: "4px"
                                  }}
                                >
                              <img
                                src={item.img}
                                alt={item.name}
                                className="img-fluid"
                              />
                               <h2
                                  style={{
                                    fontSize:"11px",
                                    textAlign:"center",
                                    marginBottom:"0" ,
                                    marginTop:"5px"
                                  }}
                                >
                             {item.name}
                            </h2>
                            </div>
                          </div>
                        ))}
                    </div>
                </div>
                </div>
               </div>

            <div className="col-md-4 order-1 order-sm-2">
                  <GalleryImage mainimage={selectedImage.img} name={selectedImage.name} />
                  {/* {isLoading ? (
                      <Skeleton count={1} height={30} width={430} className="mb-2" />
                    ) : (
                      <SpecifIcation />
                    )} */}
                 </div>
            </div>
            <div className="row row-cols-1 mt-4">
                 <div className="col-md-8 col-sm-12 col-12">
                    <div className="cartboxshadow"> 
                           <CartList />
                     </div>
                  </div>
                  <div className="col-md-5 col-sm-12 col-12">&nbsp;</div> 
              </div>
            </div>
        </section>
      </>
    </SkeletonTheme>
  );
}
export default ProductDetails;